import { Injectable } from '@angular/core';
import { LoopBackConfig, LoggerService, Account } from '../shared/sdk';
import { ToastService } from '../shared/modules/toast/toast.service';
import { TranslateService } from '@ngx-translate/core';

import { BASE_URL, API_VERSION } from '../shared/base-url';
import { CacheService } from '../shared/services/cache.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Guestbook } from './guestbook';
import { map, catchError, switchMap } from 'rxjs/operators';
import { throwError, ReplaySubject, Observable } from 'rxjs';
import { Property } from './property';
import { AccountService } from '../accounts/account.service';

export interface APIdata {
  page: number;
  pagescount: number;
  prevpage: number;
  nextpage: number;
  count: number;
  list: Guestbook[] | Property[];
}

export interface APIoccupancy {
  capacity: number;
  occupancy: number;
}

export interface APIresponse {
  status: boolean;
  data: APIdata;
  occupancy?: APIoccupancy;
  moredata?: any;
}

export const IDdocumentTypes = [
  {
    code: 'P',
    caption: 'Passport',
    caption_sl: 'Potni list',
    isDefault: 'true',
    createdTime: '2017-11-26T13:55:33.686Z',
    editedTime: '2017-11-28T13:40:51.281Z',
    documentTypeBlinkCode: 'MRTD_TYPE_PASSPORT',
    id: '5a1ac7d50a21a130f1f2d370',
  },
  {
    code: 'I',
    caption: 'Indentity card',
    caption_sl: 'Osebna izkaznica',
    isDefault: 'false',
    createdTime: '2017-11-26T13:56:00.798Z',
    editedTime: '2017-12-01T17:02:38.666Z',
    documentTypeBlinkCode: 'MRTD_TYPE_IDENITY_CARD',
    id: '5a1ac7f00a21a130f1f2d371',
  },
  {
    code: 'V',
    caption: 'Drivers licence',
    caption_sl: 'Vozniško dovoljenje',
    isDefault: 'false',
    createdTime: '2017-11-26T13:56:19.645Z',
    editedTime: '2017-11-26T13:56:19.645Z',
    id: '5a1ac8030a21a130f1f2d372',
  },
  {
    code: 'H',
    caption: 'Travel documents under international treaty',
    caption_sl: 'Potne listine po mednarodni pogodbi',
    isDefault: 'false',
    createdTime: '2017-11-26T13:56:46.166Z',
    editedTime: '2017-12-01T17:35:46.484Z',
    documentTypeBlinkCode: 'MRTD_TYPE_VISA',
    id: '5a1ac81e0a21a130f1f2d373',
  },
  {
    code: 'F',
    caption: 'Border pass',
    caption_sl: 'Obmejna prepustnica',
    isDefault: 'false',
    createdTime: '2017-11-26T13:56:58.983Z',
    editedTime: '2017-11-27T17:15:56.860Z',
    id: '5a1ac82a0a21a130f1f2d374',
  },
  {
    code: 'L',
    caption:
      'Children who are citizens of Slovenia without identification documents',
    caption_sl: 'Otroci, državljani RS, brez dokumenta',
    isDefault: 'false',
    createdTime: '2017-11-26T13:57:13.837Z',
    editedTime: '2017-11-27T17:11:26.536Z',
    id: '5a1ac8390a21a130f1f2d375',
  },
  {
    code: 'O',
    caption: 'Weapon permit',
    caption_sl: 'Orožni list',
    isDefault: 'false',
    createdTime: '2017-11-26T13:57:27.600Z',
    editedTime: '2017-11-27T17:07:49.838Z',
    id: '5a1ac8470a21a130f1f2d376',
  },
  {
    code: 'U',
    caption: 'Administrative documents',
    caption_sl: 'Upravne listine',
    isDefault: 'false',
    createdTime: '2017-11-26T13:57:39.688Z',
    editedTime: '2017-11-27T17:17:15.585Z',
    id: '5a1ac8530a21a130f1f2d377',
  },
];

export const touristTaxTypes = [
  {
    code: '0',
    proc: '1',
    caption: 'Full tourist tax (no exemption)',
    caption_sl: 'Polna turistična taksa (ni oprostitve)',
    isDefault: 'true',
    createdTime: '2017-11-26T13:44:25.936Z',
    editedTime: '2018-03-22T21:18:40.605Z',
    rule: '',
    propertyDefaultSel: 'true',
    isHidden: 'false',
    id: '5a1ac53970564b30b9e32328',
  },
  {
    code: '1',
    proc: '0',
    caption: 'Exemption - children under the age of 7',
    caption_sl: 'Oprostitev - otrok do 7. leta starosti',
    isDefault: 'false',
    createdTime: '2017-11-26T13:44:50.430Z',
    editedTime: '2017-12-02T09:13:24.273Z',
    rule: 'AGElt7',
    propertyDefaultSel: 'false',
    id: '5a1ac55270564b30b9e32329',
  },
  {
    code: '2',
    proc: '0',
    caption: 'Exemption - a medical referral',
    caption_sl: 'Oprostitev - zdravniška napotnica',
    isDefault: 'false',
    createdTime: '2017-11-26T13:45:18.508Z',
    editedTime: '2017-11-27T16:10:50.862Z',
    id: '5a1ac56e70564b30b9e3232a',
  },
  {
    code: '3',
    proc: '0',
    caption: 'Exemption - disability or physical impairment',
    caption_sl: 'Oprostitev - invalidnost, telesna okvara',
    isDefault: 'false',
    createdTime: '2017-11-26T13:45:29.244Z',
    editedTime: '2017-11-27T17:02:10.674Z',
    id: '5a1ac57970564b30b9e3232b',
  },
  {
    code: '4',
    proc: '0',
    caption: 'Exemption - children with special needs',
    caption_sl: 'Oprostitev - otrok s posebnimi potrebami',
    isDefault: 'false',
    createdTime: '2017-11-26T13:45:38.616Z',
    editedTime: '2017-11-27T16:12:29.327Z',
    id: '5a1ac58270564b30b9e3232c',
  },
  {
    code: '5',
    proc: '0',
    caption: 'Exemption - participants in educational programs',
    caption_sl: 'Oprostitev - vzgojno-izobraževalni program',
    isDefault: 'false',
    createdTime: '2017-11-26T13:46:05.050Z',
    editedTime: '2017-11-27T16:16:14.402Z',
    id: '5a1ac59d7f4fac30f1ee7e57',
  },
  {
    code: '6',
    proc: '0',
    caption:
      'Exemption - pupils and students in student accommodation facilities',
    caption_sl: 'Oprostitev - dijaki, študenti v domovih',
    isDefault: 'false',
    createdTime: '2017-11-26T13:46:13.487Z',
    editedTime: '2018-03-23T08:21:33.402Z',
    rule: '',
    propertyDefaultSel: 'true',
    isHidden: 'true',
    id: '5a1ac5a57f4fac30f1ee7e58',
  },
  {
    code: '7',
    proc: '0',
    caption:
      'Exemption - persons who are on temporary work for more than 30 days (ATTENTION: first 30 days is not tax free - calculated in tourist tax report)',
    caption_sl:
      'Oprostitev - začasno delo nad 30 dni (POZOR: polna taksa za prvih 30 dni bivanja - vidno v poročilu turistične takse)',
    isDefault: 'false',
    createdTime: '2017-11-26T13:46:21.938Z',
    editedTime: '2019-08-13T11:05:01.295Z',
    rule: '',
    propertyDefaultSel: 'false',
    isHidden: 'false',
    id: '5a1ac5ad7f4fac30f1ee7e59',
  },
  {
    code: '8',
    proc: '0',
    caption: 'Exemption - international regulations and agreements',
    caption_sl: 'Oprostitev - mednarodna pogodba',
    isDefault: 'false',
    createdTime: '2017-11-26T13:46:38.869Z',
    editedTime: '2017-11-27T17:00:05.432Z',
    id: '5a1ac5be7f4fac30f1ee7e5a',
  },
  {
    code: '9',
    proc: '0',
    caption: 'Exemption - members of the Alpine Association of Slovenia',
    caption_sl: 'Oprostitev - planinski dom (člani PZS)',
    isDefault: 'false',
    createdTime: '2017-11-26T13:46:49.539Z',
    editedTime: '2018-03-23T08:21:55.839Z',
    rule: '',
    propertyDefaultSel: 'true',
    isHidden: 'true',
    id: '5a1ac5c97f4fac30f1ee7e5b',
  },
  {
    code: '10',
    proc: '0',
    caption: 'Exemption - municipality regulation',
    caption_sl: 'Oprostitev - predpis občine',
    isDefault: 'false',
    createdTime: '2017-11-26T13:46:59.854Z',
    editedTime: '2017-12-02T09:14:58.906Z',
    rule: '',
    propertyDefaultSel: 'true',
    id: '5a1ac5d37f4fac30f1ee7e5c',
  },
  {
    code: '11',
    proc: '0.5',
    caption: 'Half exemption (50%) - persons aged 7 to 18',
    caption_sl: 'Polovično plačilo (50%) - oseba od 7. do 18. leta starosti',
    isDefault: 'false',
    createdTime: '2017-11-26T13:47:12.818Z',
    editedTime: '2017-12-02T09:14:08.724Z',
    rule: 'AGE7-18',
    propertyDefaultSel: 'false',
    id: '5a1ac5e07f4fac30f1ee7e5d',
  },
  {
    code: '12',
    proc: '0.5',
    caption:
      'Half exemption (50%) - the international youth hostels network IYHF',
    caption_sl: 'Polovično plačilo (50%) - mladinska prenočišča IYHF',
    isDefault: 'false',
    createdTime: '2017-11-26T13:47:24.463Z',
    editedTime: '2017-12-02T09:14:53.006Z',
    rule: '',
    propertyDefaultSel: 'true',
    id: '5a1ac5ec7f4fac30f1ee7e5e',
  },
  {
    code: '13',
    proc: '0.5',
    caption: 'Half exemption (50%) - campsite tourists',
    caption_sl: 'Polovično plačilo (50%) - turisti v kampih',
    isDefault: 'false',
    createdTime: '2017-11-26T13:47:41.268Z',
    editedTime: '2018-03-23T08:22:12.889Z',
    rule: '',
    propertyDefaultSel: 'true',
    isHidden: 'true',
    id: '5a1ac5fd7f4fac30f1ee7e5f',
  },
  {
    code: '14',
    proc: '0.5',
    caption: 'Half exemption (50%) - municipality regulation',
    caption_sl: 'Polovično plačilo (50%) - predpis občine',
    isDefault: 'false',
    createdTime: '2017-11-26T13:47:52.252Z',
    editedTime: '2017-12-02T09:14:37.882Z',
    rule: '',
    propertyDefaultSel: 'true',
    id: '5a1ac6087f4fac30f1ee7e60',
  },
  {
    code: '15',
    proc: '0.5',
    caption: 'Partialy exemption - municipality regulation',
    caption_sl: 'Delno plačilo - predpis občine',
    isDefault: 'false',
    createdTime: '2017-11-26T13:48:05.767Z',
    editedTime: '2017-12-02T09:14:41.539Z',
    rule: '',
    propertyDefaultSel: 'true',
    id: '5a1ac6157f4fac30f1ee7e61',
  },
  {
    code: '16',
    proc: '0',
    caption: 'Exemption - no overnight stay (daily rest)',
    caption_sl: 'ni plačila - ni storitve prenočevanja (dnevni počitek, ipd.)',
    isDefault: 'false',
    createdTime: '2017-11-26T13:48:25.348Z',
    editedTime: '2017-12-02T09:14:18.560Z',
    rule: 'NOOVERNIGHT',
    propertyDefaultSel: 'false',
    id: '5a1ac6297f4fac30f1ee7e62',
  },
  {
    code: '17',
    proc: '0',
    caption:
      'Exemption (100 %) - participants of vacationing with societies in public interest',
    caption_sl:
      'Oprostitev (100 %) - udeleženci letovanj prek društev v javnem interesu',
    isDefault: 'false',
    rule: '',
    propertyDefaultSel: 'false',
    createdTime: '2018-03-22T09:38:40.217Z',
    editedTime: '2018-03-22T09:38:40.217Z',
    id: '5ab379a04c880d4e1ee6a6cd',
  },
  {
    code: '18',
    proc: '0',
    caption:
      'Exemption (100 %) - volunteers for elimination of natural disasters',
    caption_sl:
      'Oprostitev (100 %) - prostovoljci za odpravo elementarnih nesreč',
    isDefault: 'false',
    rule: '',
    propertyDefaultSel: 'false',
    createdTime: '2018-03-22T09:41:48.686Z',
    editedTime: '2018-03-22T09:41:48.686Z',
    id: '5ab37a5c4c880d4e1ee6a6ce',
  },
  {
    code: '19',
    proc: '0',
    caption: 'Exemption (100 %) - police officers while on duty',
    caption_sl: 'Oprostitev (100 %) - policisti v obdobju opravljanja nalog',
    isDefault: 'false',
    rule: '',
    propertyDefaultSel: 'false',
    createdTime: '2018-03-22T09:42:54.791Z',
    editedTime: '2018-03-22T09:42:54.791Z',
    id: '5ab37a9e4c880d4e1ee6a6cf',
  },
];

export const countries = {
  AF: 'Afganistan',
  AX: 'Alandski otoki',
  AL: 'Albanija',
  DZ: 'Al\u017eirija',
  AS: 'Ameri\u0161ka Samoa',
  VI: 'Ameri\u0161ki Devi\u0161ki otoki',
  AD: 'Andora',
  AO: 'Angola',
  AI: 'Angvila',
  AQ: 'Antarktika',
  AG: 'Antigva in Barbuda',
  AR: 'Argentina',
  AM: 'Armenija',
  AW: 'Aruba',
  AU: 'Avstralija',
  AT: 'Avstrija',
  AZ: 'Azerbajd\u017ean',
  BS: 'Bahami',
  BH: 'Bahrajn',
  BD: 'Banglade\u0161',
  BB: 'Barbados',
  BE: 'Belgija',
  BZ: 'Belize',
  BY: 'Belorusija',
  BJ: 'Benin',
  BM: 'Bermudi',
  BW: 'Bocvana',
  BG: 'Bolgarija',
  BO: 'Bolivija',
  BA: 'Bosna in Hercegovina',
  CX: 'Bo\u017ei\u010dni otok',
  BR: 'Brazilija',
  VG: 'Britanski Devi\u0161ki otoki',
  IO: 'Britansko ozemlje v Indijskem oceanu',
  BN: 'Brunej',
  BF: 'Burkina Faso',
  BI: 'Burundi',
  BT: 'Butan',
  CF: 'Centralnoafri\u0161ka republika',
  EA: 'Ceuta in Melilla',
  CY: 'Ciper',
  CK: 'Cookovi otoki',
  CW: 'Cura\u00e7ao',
  TD: '\u010cad',
  CZ: '\u010ce\u0161ka',
  CL: '\u010cile',
  ME: '\u010crna gora',
  DK: 'Danska',
  CD: 'Demokrati\u010dna republika Kongo',
  DG: 'Diego Garcia',
  DM: 'Dominika',
  DO: 'Dominikanska republika',
  UM: 'Druga ameri\u0161ka ozemlja v Tihem oceanu',
  DJ: 'D\u017eibuti',
  EG: 'Egipt',
  EC: 'Ekvador',
  GQ: 'Ekvatorialna Gvineja',
  ER: 'Eritreja',
  EE: 'Estonija',
  ET: 'Etiopija',
  FK: 'Falklandski otoki',
  FO: 'Ferski otoki',
  FJ: 'Fid\u017ei',
  PH: 'Filipini',
  FI: 'Finska',
  FR: 'Francija',
  GF: 'Francoska Gvajana',
  PF: 'Francoska Polinezija',
  TF: 'Francosko ju\u017eno ozemlje',
  GA: 'Gabon',
  GM: 'Gambija',
  GH: 'Gana',
  GI: 'Gibraltar',
  GR: 'Gr\u010dija',
  GD: 'Grenada',
  GL: 'Grenlandija',
  GE: 'Gruzija',
  GU: 'Guam',
  GG: 'Guernsey',
  GP: 'Gvadalupe',
  GY: 'Gvajana',
  GT: 'Gvatemala',
  GN: 'Gvineja',
  GW: 'Gvineja Bissau',
  HT: 'Haiti',
  HN: 'Honduras',
  HR: 'Hrva\u0161ka',
  IN: 'Indija',
  ID: 'Indonezija',
  IQ: 'Irak',
  IR: 'Iran',
  IE: 'Irska',
  IS: 'Islandija',
  IT: 'Italija',
  IL: 'Izrael',
  JM: 'Jamajka',
  JP: 'Japonska',
  YE: 'Jemen',
  JE: 'Jersey',
  JO: 'Jordanija',
  GS: 'Ju\u017ena Georgia in Ju\u017eni Sandwichevi otoki',
  KR: 'Ju\u017ena Koreja',
  SS: 'Ju\u017eni Sudan',
  ZA: 'Ju\u017enoafri\u0161ka republika',
  KY: 'Kajmanski otoki',
  KH: 'Kambod\u017ea',
  CM: 'Kamerun',
  CA: 'Kanada',
  IC: 'Kanarski otoki',
  QA: 'Katar',
  KZ: 'Kazahstan',
  KE: 'Kenija',
  KG: 'Kirgizistan',
  KI: 'Kiribati',
  CN: 'Kitajska',
  CC: 'Kokosovi otoki',
  CO: 'Kolumbija',
  KM: 'Komori',
  CG: 'Kongo - Brazzaville',
  XK: 'Kosovo',
  CR: 'Kostarika',
  CU: 'Kuba',
  KW: 'Kuvajt',
  LA: 'Laos',
  LV: 'Latvija',
  LS: 'Lesoto',
  LB: 'Libanon',
  LR: 'Liberija',
  LY: 'Libija',
  LI: 'Lihten\u0161tajn',
  LT: 'Litva',
  LU: 'Luksemburg',
  MG: 'Madagaskar',
  HU: 'Mad\u017earska',
  MK: 'Makedonija',
  MW: 'Malavi',
  MV: 'Maldivi',
  MY: 'Malezija',
  ML: 'Mali',
  MT: 'Malta',
  MA: 'Maroko',
  MH: 'Marshallovi otoki',
  MQ: 'Martinik',
  MU: 'Mauritius',
  MR: 'Mavretanija',
  YT: 'Mayotte',
  MX: 'Mehika',
  FM: 'Mikronezija',
  MM: 'Mjanmar (Burma)',
  MD: 'Moldavija',
  MC: 'Monako',
  MN: 'Mongolija',
  MS: 'Montserrat',
  MZ: 'Mozambik',
  NA: 'Namibija',
  NR: 'Nauru',
  DE: 'Nem\u010dija',
  NP: 'Nepal',
  NE: 'Niger',
  NG: 'Nigerija',
  NI: 'Nikaragva',
  NU: 'Niue',
  NL: 'Nizozemska',
  BQ: 'Nizozemski Karibi',
  NF: 'Norfol\u0161ki otok',
  NO: 'Norve\u0161ka',
  NC: 'Nova Kaledonija',
  NZ: 'Nova Zelandija',
  OM: 'Oman',
  TC: 'Oto\u010dji Turks in Caicos',
  AC: 'Otok Ascension',
  IM: 'Otok Man',
  PK: 'Pakistan',
  PW: 'Palau',
  PS: 'Palestinsko ozemlje',
  PA: 'Panama',
  PG: 'Papua Nova Gvineja',
  PY: 'Paragvaj',
  PE: 'Peru',
  PN: 'Pitcairn',
  PL: 'Poljska',
  PR: 'Portoriko',
  PT: 'Portugalska',
  HK: 'Posebno administrativno obmo\u010dje LR Kitajske Hong Kong',
  MO: 'Posebno administrativno obmo\u010dje LR Kitajske Macao',
  RE: 'Reunion',
  RO: 'Romunija',
  RW: 'Ruanda',
  RU: 'Rusija',
  BL: 'Saint Barth\u00e9lemy',
  KN: 'Saint Kitts in Nevis',
  LC: 'Saint Lucia',
  MF: 'Saint Martin',
  PM: 'Saint Pierre in Miquelon',
  VC: 'Saint Vincent in Grenadine',
  SB: 'Salomonovi otoki',
  SV: 'Salvador',
  WS: 'Samoa',
  SM: 'San Marino',
  ST: 'Sao Tome in Principe',
  SA: 'Saudova Arabija',
  SC: 'Sej\u0161eli',
  SN: 'Senegal',
  KP: 'Severna Koreja',
  MP: 'Severni Marianski otoki',
  SL: 'Sierra Leone',
  SG: 'Singapur',
  SX: 'Sint Maarten',
  SY: 'Sirija',
  CI: 'Slonoko\u0161\u010dena obala',
  SK: 'Slova\u0161ka',
  SI: 'Slovenija',
  SO: 'Somalija',
  RS: 'Srbija',
  SD: 'Sudan',
  SR: 'Surinam',
  SJ: 'Svalbard in Jan Mayen',
  SZ: 'Svazi',
  SH: 'Sveta Helena',
  ES: '\u0160panija',
  LK: '\u0160rilanka',
  SE: '\u0160vedska',
  CH: '\u0160vica',
  TJ: 'Tad\u017eikistan',
  TH: 'Tajska',
  TW: 'Tajvan',
  TZ: 'Tanzanija',
  TG: 'Togo',
  TK: 'Tokelau',
  TO: 'Tonga',
  TT: 'Trinidad in Tobago',
  TA: 'Tristan da Cunha',
  TN: 'Tunizija',
  TR: 'Tur\u010dija',
  TM: 'Turkmenistan',
  TV: 'Tuvalu',
  UG: 'Uganda',
  UA: 'Ukrajina',
  UY: 'Urugvaj',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VA: 'Vatikan',
  GB: 'Velika Britanija',
  VE: 'Venezuela',
  VN: 'Vietnam',
  TL: 'Vzhodni Timor',
  WF: 'Wallis in Futuna',
  EH: 'Zahodna Sahara',
  ZM: 'Zambija',
  US: 'Zdru\u017eene dr\u017eave Amerike',
  AE: 'Zdru\u017eeni arabski emirati',
  CV: 'Zelenortski otoki',
  ZW: 'Zimbabve',
};

@Injectable()
export class GuestbookService {
  apiKey = environment.guestbookApiKey;
  documentTypes = IDdocumentTypes;
  name = 'Guest';
  plural = 'Guests';
  taxTypes = touristTaxTypes;
  countries = countries;
  countriesA: any[] = [];
  protected _token: string;
  private token$: ReplaySubject<string> = new ReplaySubject(1);
  readonly token: Observable<string> = this.token$.asObservable();

  constructor(
    protected cacheService: CacheService,
    protected log: LoggerService,
    protected toastService: ToastService,
    protected translate: TranslateService,
    private accountService: AccountService,
    private http: HttpClient,
  ) {
    LoopBackConfig.setBaseURL(BASE_URL);
    LoopBackConfig.setApiVersion(API_VERSION);

    for (const [key, value] of Object.entries(this.countries)) {
      this.countriesA.push({ id: key, name: value });
    }
  }

  create(data: any, toastr = true) {
    return this.http
      .post(`${environment.guestbookUrl}/v2/guestbook/`, data, {
        headers: {
          Authorization: `Bearer ${this._token}`,
          'X-mugo-apiKey': this.apiKey,
        },
      })
      .pipe(
        map((res: APIresponse) => {
          if (toastr) {
            this.toastService.success(
              this.translate.instant(`${this.name} successfully created.`),
            );
          }

          return !!res.data;
        }),
        catchError((err) => {
          if (err.status === 401) {
            this.onAuthError();
          } else if (toastr) {
            this.toastService.error(
              this.translate.instant(
                `Error creating ${this.plural}, please try again or contact support.`,
              ),
            );
          }

          return throwError(`Error creating ${this.plural}`);
        }),
      );
  }

  deleteById(id: string, toastr = true): Observable<boolean> {
    return this.http
      .delete(`${environment.guestbookUrl}/v2/guestbook/${id}?origstatus=1`, {
        headers: {
          Authorization: `Bearer ${this._token}`,
          'X-mugo-apiKey': this.apiKey,
        },
      })
      .pipe(
        map((res: APIresponse) => {
          if (toastr) {
            this.toastService.success(
              this.translate.instant(`${this.name} successfully deleted.`),
            );
          }

          return !!res.data;
        }),
        catchError((err) => {
          if (err.status === 401) {
            this.onAuthError();
          } else if (toastr) {
            this.toastService.error(
              this.translate.instant(
                `Error deleting ${this.plural}, please try again or contact support.`,
              ),
            );
          }

          return throwError(`Error deleting ${this.plural}`);
        }),
      );
  }

  get(
    propertyId: string,
    page = 1,
    limit = 1000,
    search: string,
    sort: any = {},
    force = false,
    toastr = true,
  ): Observable<APIdata> {
    this.log.log(`${this.name}Service: get`);
    sort = encodeURIComponent(JSON.stringify(sort));

    let url = `${environment.guestbookUrl}/v2/guestbook/?page=${page}&pagelimit=${limit}&propertyId=${propertyId}&sort=${sort}`;
    if (search) {
      url += `&searchQ=${search}`;
    }

    return this.http
      .get(url, {
        headers: {
          Authorization: `Bearer ${this._token}`,
          'X-mugo-apiKey': this.apiKey,
        },
      })
      .pipe(
        map((res: APIresponse) => {
          return res.data;
        }),
        catchError((err) => {
          if (err.status === 401) {
            this.onAuthError();
          } else if (toastr) {
            this.toastService.error(
              this.translate.instant(
                `Error loading ${this.plural}, please try again or contact support.`,
              ),
            );
          }

          return throwError(`Error loading ${this.plural}`);
        }),
      );
  }

  getProperties(
    page = 1,
    limit = 1000,
    sort: any = {},
    force = false,
    toastr = true,
  ): Observable<APIdata> {
    this.log.log(`${this.name}Service: getProperty`);
    sort = encodeURIComponent(JSON.stringify(sort));

    return this.http
      .get(
        `${environment.guestbookUrl}/v2/properties/?page=${page}&pagelimit=${limit}&sort=${sort}`,
        {
          headers: {
            Authorization: `Bearer ${this._token}`,
            'X-mugo-apiKey': this.apiKey,
          },
        },
      )
      .pipe(
        map((res: APIresponse) => {
          return res.data;
        }),
        catchError((err) => {
          if (err.status === 401) {
            this.onAuthError();
          } else if (toastr) {
            this.toastService.error(
              this.translate.instant(
                'Error loading properties, please try again or contact support.',
              ),
            );
          }

          return throwError('Error loading properties');
        }),
      );
  }

  getReport(
    propertyId: string,
    year: string,
    month: string,
    force = false,
    toastr = true,
  ): Observable<any> {
    this.log.log(`${this.name}Service: getReport`);

    return this.http
      .get(
        `${environment.guestbookUrl}/v2/reports/?propertyId=${propertyId}&filterYear=${year}&filterMonth=${month}&type=ttaxFull`,
        {
          headers: {
            Authorization: `Bearer ${this._token}`,
            'X-mugo-apiKey': this.apiKey,
          },
        },
      )
      .pipe(
        catchError((err) => {
          if (err.status === 401) {
            this.onAuthError();
          } else if (toastr) {
            this.toastService.error(
              this.translate.instant(
                'Error loading report, please try again or contact support.',
              ),
            );
          }

          return throwError('Error loading report');
        }),
      );
  }

  getById(
    id: string,
    filter = {},
    force = true,
    toastr = true,
  ): Observable<Guestbook> {
    return this.http.get<Guestbook>(
      `${environment.guestbookUrl}/v2/guestbook/${id}`,
      {
        headers: {
          Authorization: `Bearer ${this._token}`,
          'X-mugo-apiKey': this.apiKey,
        },
      },
    );
  }

  login(
    creds: { email: string; password: string },
    toastr = true,
  ): Observable<any> {
    return this.http
      .post<Guestbook>(`${environment.guestbookUrl}/v2/users/login`, creds, {
        headers: {
          'X-mugo-apiKey': this.apiKey,
        },
      })
      .pipe(
        map((res: any) => {
          this.setToken(res.data.authToken);
          this.onAuthenticated();

          return res.data;
        }),
        catchError((err) => {
          this.log.log(err);

          if (toastr) {
            if (
              err.error?.error &&
              [1, 2].indexOf(err.error.error.code) !== -1
            ) {
              this.toastService.warning(
                this.translate.instant(
                  'You have entered an invalid e-mail or password',
                ),
                this.translate.instant('Invalid credentials'),
              );
            } else {
              this.toastService.error(
                this.translate.instant(
                  'Error loging in, please try again or contact support.',
                ),
              );
            }
          }

          return throwError('Error loging in');
        }),
      );
  }

  update(id: string, data: any, toastr = true) {
    return this.http
      .post(`${environment.guestbookUrl}/v2/guestbook/${id}`, data, {
        headers: {
          Authorization: `Bearer ${this._token}`,
          'X-mugo-apiKey': this.apiKey,
        },
      })
      .pipe(
        map((res: APIresponse) => {
          if (toastr) {
            this.toastService.success(
              this.translate.instant(`${this.name} successfully updated.`),
            );
          }

          return !!res.data;
        }),
        catchError((err) => {
          if (err.status === 401) {
            this.onAuthError();
          } else if (toastr) {
            this.toastService.error(
              this.translate.instant(
                `Error updating ${this.plural}, please try again or contact support.`,
              ),
            );
          }

          return throwError(`Error updating ${this.plural}`);
        }),
      );
  }

  setToken(token) {
    this._token = token;
    this.token$.next(this._token);
  }

  private onAuthenticated() {
    // Attach token to current user
    this.accountService.active
      .pipe(
        switchMap((account: Account) => {
          return this.accountService.patch(
            account.id,
            {
              custom: {
                snapguestToken: this._token,
              },
            },
            false,
          );
        }),
      )
      .subscribe(
        () => {},
        () => {},
      );
  }

  private onAuthError() {
    this._token = null;
    this.token$.next(this._token);

    this.accountService
      .getCurrent()
      .pipe(
        switchMap((account: Account) => {
          return this.accountService.patch(
            account.id,
            {
              custom: {
                snapguestToken: null,
              },
            },
            false,
          );
        }),
      )
      .subscribe(
        () => {},
        () => {},
      );
  }
}
